import { render } from "./CommunicationTargetStore.vue?vue&type=template&id=6afdc1b3&scoped=true&ts=true"
import script from "./CommunicationTargetStore.vue?vue&type=script&lang=ts"
export * from "./CommunicationTargetStore.vue?vue&type=script&lang=ts"

import "./CommunicationTargetStore.vue?vue&type=style&index=0&id=6afdc1b3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afdc1b3"]])

export default __exports__